// extracted by mini-css-extract-plugin
module.exports = {"container":"az_sUc","label":"az_tUc","productName":"az_uUc","link":"az_vUc"};